export default {
    ALL: 'ALL',
    TREASURY: 'TREASURY',
    EMPLOYEE: 'EMPLOYEE',
    NOMINEE: 'NOMINEE',
    DIRECTORS_AND_OFFICERS: 'DIRECTORS_AND_OFFICERS'
};
